/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./ViewCPDetails.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";

import { updateStatus, insertCpLogs, CreateNewBroker, getKYCDocuments, getDeletedCpData } from "../../Services/ChannelPartner";
import { uploadCpToContactGroup } from "../../Services/CpSourcingApis";
import RejectReason from "../RejectReason/RejectReason";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));
export default function ViewCPDetails({
  open,
  data,
  handleClose,
  showStatusButton,
  loggedInUser,
  returnResp,
  showError,
  showInfo,
}) {
  const classes = useStyles();
  const [panCardDetails, setPanCardDetails] = useState("");
  const [reraDetails, setReraDetails] = useState("");
  const [gstDetails, setGstDetails] = useState("");
  const [rejectResponse, setRejectResponse] = useState(false);
  const [displayName, setDisplayName] = useState(data.name);
  const [displayEmail, setDisplayEmail] = useState(data.email);
  const [displayContactNumber, setDisplayContactNumber] = useState(data.contactNumber);
  useEffect(() => {
    if (data.isDeleted) {
      // CpContactPerson/KycDocuments are hard-deleted once a CP is suspended;
      // pull the archived snapshot from DeletedCpFos instead.
      getDeletedCpData(data.cpId).then((archived) => {
        const kycRes = archived?.kycDocuments || [];
        setPanCardDetails(kycRes.find((el) => el.docType === "PanCard"));
        setReraDetails(kycRes.find((el) => el.docType === "Rera"));
        setGstDetails(kycRes.find((el) => el.docType === "GST"));
        setDisplayName(archived?.contactName ?? data.name);
        setDisplayEmail(archived?.contactEmail ?? data.email);
        setDisplayContactNumber(archived?.contactNumber ?? data.contactNumber);
      }).catch((err) => {
        showError("Error While loading archived CP data.Please try again later!")
        console.log("Error while loading archived CP data", err);
      });
      return;
    }
    getKYCDocuments(data.cpId).then((kycRes) => {
      setPanCardDetails(
        kycRes.find((el) => {
          if (el.docType === "PanCard") {
            return el;
          }
        })
      );
      setReraDetails(
        kycRes.find((el) => {
          if (el.docType === "Rera") {
            return el;
          }
        })
      );
      setGstDetails(
        kycRes.find((el) => {
          if (el.docType === "GST") {
            return el;
          }
        })
      );
    }).catch((err) => {
      showError("Error While loading Documents.Please try again later!")
      console.log("Error while loading Documents", err);
    })
  }, []);
  console.log("data", data);
  function closeModal() {
    handleClose();
  }
  function accept() {
    returnResp(true);
    handleClose();
    updateStatus(data.id, "approved", "")
      .then((res) => {
        console.log("res", res[0].cpId)
        // CreateNewBroker(res[0].cpId).then((BrokerResp) => {
        //   console.log("BrokerResp" , BrokerResp)
        // }).catch((err) => {
        //   console.error("BrokerResp" , err)
        // })
        // Push the approved CP into its sourcing user's SmartFlo contact group
        // (fire-and-forget — approval must not fail on telephony sync).
        uploadCpToContactGroup(data.id).catch((err) => {
          console.error("uploadCpToContactGroup failed", err?.response?.data || err.message);
        });
        insertCpLogs(data.id, "approved", loggedInUser)
          .then((resp) => {
            returnResp(true);
            handleClose();
          })
          .catch((err) => {
            showError(err.message);
          });
        console.log(res);
      })
      .catch((err) => {
        showError(err.message);
      })
      .catch((err) => {
        showError(err.message);
      });
  }
  function reject() {
    setRejectResponse(true);
  }

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.header}>
            <div className={cssClasses.headerTitle}>
              Channel Partner Details{" "}
            </div>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.5rem"} height={"1.5rem"} />
            </span>
          </div>
          <div className={cssClasses.content}>
            <div className={cssClasses.leftContent}>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.title}>{displayName}</div>
                   <div className={cssClasses.email}>
                  {displayEmail} | {displayContactNumber}
                </div>
                  <div className={cssClasses.keyValue}>
                <div className={cssClasses.key}>CP Sourcing :</div>
                {data.cpSourcingName && data.cpSourcingName !== "NA" &&
                  <div className={cssClasses.value}>
                    {data.cpSourcingName}
                  </div>
                }
                {(!data.cpSourcingName || data.cpSourcingName === "NA") &&
                  <div className={cssClasses.value}>
                    -
                  </div>
                }
              </div>
              </div>
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockTitle}>General Details</div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Billing Name :</div>
                  <div className={cssClasses.value}>
                    {data.billingName}
                  </div>
                </div>
                {[0, 0, 0].map((el, index) => {
                  return (
                    <>
                      <div className={cssClasses.keyValue}>
                        <div className={cssClasses.key}>
                          {index === 0 ? "PAN Number" : index === 1 ? "RERA Number" : 'GST Number'}:
                          {/* {el.docType === "Rera" && "RERA Number"}
                          {el.docType === "GST" && "GST Number"} */}

                        </div>
                        <div className={cssClasses.value}>{index === 0 ? panCardDetails?.docNumber ?? 'NA' : index === 1 ? reraDetails?.docNumber ?? 'NA' : gstDetails?.docNumber ?? 'NA'}</div>
                        {index === 1 && reraDetails !== undefined && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              window.open(
                                process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                reraDetails.docUrl,
                                "_blank"
                              );
                            }}
                          >
                            <OpenInNewIcon
                              sx={{
                                fontSize: 25,
                                verticalAlign: "middle",
                                color: "#344054",
                              }}
                            />
                          </span>
                        )}
                      </div>
                      <div className={cssClasses.keyValue}>
                        <div className={cssClasses.key}>
                          {index === 0 ? "PAN Name" : index === 1 ? "RERA Name" : 'GST Name'}:
                          {/* {el.docType === "PanCard" && "PAN Name"}
                          {el.docType === "Rera" && "RERA Name"}
                          {el.docType === "GST" && "GST Name"}: */}
                        </div>
                        <div
                          className={cssClasses.value}
                          style={{
                            color: "#1570ef",
                          }}
                        >
                          {index === 0
                            ? panCardDetails?.docHolderName ?? "NA"
                            : index === 1
                            ? reraDetails?.docHolderName ?? "NA"
                            : gstDetails?.docHolderName && gstDetails.docHolderName !== "NA"
                            ? gstDetails.docHolderName
                            : data.gstBusinessName && data.gstBusinessName !== "NA"
                            ? data.gstBusinessName
                            : data.gstLegalName ?? "NA"}
                        </div>
                      </div>
                    </>
                  );
                })}

                {/* <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>RERA Document :</div>
                  <a className={cssClasses.value} style={{
                    textDecoration: "none"
                  }} href={'https://bcvhdafxyvvaupmnqukc.supabase.co/storage/v1/object/public/'+reraDetails.docUrl} target="_blank" rel="noreferrer">View Doc</a>
                </div> */}
              </div>
            </div>
            <div className={cssClasses.rightContent}>
              <div className={cssClasses.keyValue}>
                <div className={cssClasses.key}>Type :</div>
                <div className={cssClasses.value}>{data.type}</div>
              </div>
              <div className={cssClasses.keyValue}>
                <div className={cssClasses.key}>Recommended by :</div>
                {data.recommendedBySalesId &&
                  <div className={cssClasses.value}>
                    {data.recommendedBySalesId}
                  </div>
                }
                {!data.recommendedBySalesId &&
                  <div className={cssClasses.value}>
                    -
                  </div>
                }
              </div>
            
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockTitle}>Bank Details</div>

                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Account Holder Name :</div>
                  <div className={cssClasses.value}>
                    {data.bankAccountHolderName}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Account Number :</div>
                  <div className={cssClasses.value}>
                    {data.BankAccountNumberText ?? data.bankAccountNumber}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>IFSC Code :</div>
                  <div className={cssClasses.value}>
                    {data.bankIFSCCode}
                  </div>
                </div>
                <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Branch Name :</div>
                  <div className={cssClasses.value}>
                    {data.bankBranchName}
                  </div>
                </div>
                     <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>SignIn Date :</div>
                  <div className={cssClasses.value}>
                    {data.created_at ? new Date(data.created_at).toLocaleDateString() : 'NA'}
                  </div>
                </div>
                  <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Last Updated Date :</div>
                  <div className={cssClasses.value}>
                    {data.last_updated_at ? new Date(data.last_updated_at).toLocaleDateString() : 'NA'}
                  </div>
                </div>
                 {/* <div className={cssClasses.keyValue}>
                  <div className={cssClasses.key}>Proproitership :</div>
                  <div className={cssClasses.value}>
                 
                    {data.proprietorship_name &&
                      data.proprietorship_name.trim().toLowerCase() !== "proprietorship"
                      ? data.proprietorship_name
                      : "NA"}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          {showStatusButton && (
            <div className={cssClasses.wrapperButtons}>
              {data.cpId.approvalStatus === "pending" && (
                <div>
                  <Button
                    style={{
                      color: "#344054",
                      backgroundColor: "#ffffff",
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                    }}
                    btnName={"Reject"}
                    clicked={reject}
                  />
                </div>
              )}

              <div>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#1570EF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  btnName={"Accept"}
                  clicked={accept}
                />
              </div>
            </div>
          )}
        </div>
        {rejectResponse && (
          <RejectReason
            open={rejectResponse}
            handleClose={() => {
              setRejectResponse(false);
            }}
            loggedInUserId={loggedInUser}
            saveResp={(value) => {
              if (value) {
                returnResp(true);
              } else {
                returnResp(false);
              }
              handleClose();
            }}
            data={data}
            showError={showError}
            showInfo={showInfo}
          />
        )}
      </Box>
    </Modal>
  );
}
